import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import * as i18next from 'i18next';
import { useDeleteSite } from '../../hooks/useSiteInfo';

interface IProps {
    sitename: string;
    siteId: number;
    show: boolean;
    handleClose: (deleted: boolean) => void;
}

function SiteInfoModal({ sitename, siteId, show, handleClose }: IProps) {
    const deleteSiteMutation = useDeleteSite();

    function accept(e: React.MouseEvent) {
        e.preventDefault();
        deleteSiteMutation.mutate(siteId, {
            onSuccess: () => handleClose(true)
        });
    }

    return (
        <Dialog open={show} onClose={() => handleClose(false)}>
            <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
                {i18next.t('adminsites.deletesite')}
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                <p>{i18next.t('adminsites.suretodelete')} {sitename}?</p>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                <Button variant="contained" color="error" onClick={accept}>
                    {i18next.t('adminsites.deletebutton')}
                </Button>
                <Button variant="outlined" color="inherit" onClick={() => handleClose(false)}>
                    {i18next.t('adminsites.cancelbutton')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SiteInfoModal;
